import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(function () {
      return [(_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalComponent), _mergeProps({
        onConfirmNumber: _ctx.handleCapturedEvent
      }, _ctx.modalProps), null, 16, ["onConfirmNumber"]))];
    }),
    _: 1
  });
}